import { render } from "./OutputOperate.vue?vue&type=template&id=4b4a3f07&scoped=true"
import script from "./OutputOperate.vue?vue&type=script&lang=js"
export * from "./OutputOperate.vue?vue&type=script&lang=js"

import "./OutputOperate.vue?vue&type=style&index=0&id=4b4a3f07&lang=scss&scoped=true"

import exportComponent from "/Users/opm/opm-vue-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b4a3f07"]])

export default __exports__